export default function headerTemplate () {
	const header = document.querySelector('.site-header');
	if (! header) return;

	const toggle = header.querySelector('.menu-toggle');
	const menu = document.getElementById('primary-menu');
	const setOpen = (open) => {
		header.classList.toggle('is-open', open);
		document.documentElement.classList.toggle('is-menu-open', open);
		if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
		window.dispatchEvent(new CustomEvent('bloom-menu'));
		if (! open) apply();
	};

	if (toggle && menu) {
		toggle.addEventListener('click', () => {
			setOpen(! header.classList.contains('is-open'));
		});
		menu.addEventListener('click', (event) => {
			if (event.target.closest('a')) setOpen(false);
		});
		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') setOpen(false);
		});
		window.addEventListener('resize', () => {
			if (window.innerWidth >= 768) setOpen(false);
		});
	}

	const toneFromColor = (color) => {
		const match = color.match(/rgba?\(([^)]+)\)/);
		if (! match) return null;
		const parts = match[1].split(',').map((part) => parseFloat(part));
		const [red, green, blue, alpha = 1] = parts;
		if (alpha < 0.6) return null;
		const luminance = (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255;
		return luminance > 0.62 ? 'light' : 'dark';
	};

	const toneUnderHeader = () => {
		const covers = [...document.querySelectorAll('.nav-cover-bar.is-fixed')].filter((bar) => {
			return getComputedStyle(bar).visibility !== 'hidden';
		});
		if (covers.length) {
			const tone = toneFromColor(getComputedStyle(covers[covers.length - 1]).backgroundColor);
			if (tone) return tone;
		}
		const probeY = Math.min(window.innerHeight - 1, Math.max(0, header.getBoundingClientRect().bottom - 8));
		const stack = document.elementsFromPoint(window.innerWidth / 2, probeY);
		for (const el of stack) {
			if (el.closest('.site-header')) continue;
			const nav = el.closest('[data-nav]');
			if (nav) return nav.dataset.nav;
			const tone = toneFromColor(getComputedStyle(el).backgroundColor);
			if (tone) return tone;
		}
		return 'light';
	};

	const footer = document.querySelector('.site-footer');
	const hero = document.querySelector('.work-hero');
	const overFooter = () => {
		if (! footer) return false;
		return footer.getBoundingClientRect().top <= header.getBoundingClientRect().bottom;
	};
	const pastHero = () => {
		if (! hero) return false;
		return hero.getBoundingClientRect().bottom <= header.getBoundingClientRect().bottom;
	};

	const homeHero = document.querySelector('.hero-home');
	const misSection = document.querySelector('.misattribution');
	const navBackground = () => {
		if (! homeHero) return;
		const cover = document.querySelector('.nav-cover-bar.is-fixed');
		const heroStillBehind = homeHero.getBoundingClientRect().bottom > header.getBoundingClientRect().bottom;
		const misStillAhead = misSection && misSection.getBoundingClientRect().bottom > header.getBoundingClientRect().top;
		let fade = 0;
		if (! cover && misStillAhead) {
			const height = homeHero.offsetHeight || 1;
			const progress = window.scrollY / height;
			fade = Math.min(1, Math.max(0, (progress - 0.4) / 0.3));
			// Hold the black plate until the next bar has reached the header.
			if (! heroStillBehind) fade = 1;
		}
		header.style.setProperty('--nav-bg', fade.toFixed(3));
	};

	let frame = 0;
	const apply = () => {
		frame = 0;
		navBackground();
		if (header.classList.contains('is-open')) return;
		const past = pastHero();
		header.classList.toggle('is-past-hero', past);
		const onFooter = overFooter();
		header.classList.toggle('is-over-footer', onFooter);
		const under = toneUnderHeader();
		const tone = (onFooter || past) && under !== 'light' ? 'dark' : under;
		document.body.classList.toggle('nav-on-light', tone === 'light');
	};
	const schedule = () => {
		if (frame) return;
		frame = requestAnimationFrame(apply);
	};

	apply();
	window.addEventListener('scroll', schedule, { passive: true });
	window.addEventListener('resize', schedule);
}
